/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/Button", "azure-devops-ui/Card", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Header", "azure-devops-ui/Link", "azure-devops-ui/Status", "azure-devops-ui/Table", "azure-devops-ui/TooltipEx", "azure-devops-ui/Util", "azure-devops-ui/Utilities/Provider", "react", "../../Resources", "../Utils", "./ResourceStatus", "./KubeCardWithTable.scss"], function (require, exports, Button_1, Card_1, String_1, Header_1, Link_1, Status_1, Table_1, TooltipEx_1, Util_1, Provider_1, React, Resources, Utils_1, ResourceStatus_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var KubeCardWithTable = /** @class */ (function (_super) {
        __extends(KubeCardWithTable, _super);
        function KubeCardWithTable() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._onItemActivated = function (event, tableRow) {
                if (_this.props.onItemActivated) {
                    _this.props.onItemActivated(event, tableRow, _this.props.items[tableRow.index]);
                }
            };
            _this._onItemSelected = function (event, tableRow) {
                if (_this.props.onItemSelected) {
                    _this.props.onItemSelected(event, tableRow, _this.props.items[tableRow.index]);
                }
            };
            return _this;
        }
        KubeCardWithTable.prototype.render = function () {
            return (React.createElement(Card_1.CustomCard, { className: Util_1.css("flex-grow", "bolt-card-no-vertical-padding", this.props.className || "") },
                this.props.headingText &&
                    React.createElement(Header_1.CustomHeader, null,
                        React.createElement(Header_1.HeaderTitleArea, null,
                            React.createElement(Header_1.HeaderTitleRow, null, (typeof this.props.headingText === "string") ?
                                React.createElement(Header_1.HeaderTitle, { className: "text-ellipsis", titleSize: 0 /* Medium */ }, this.props.headingText) :
                                React.createElement(Header_1.HeaderTitle, { className: "text-ellipsis", titleSize: 0 /* Medium */, children: this.props.headingText })),
                            this.props.headingDescription &&
                                React.createElement(Header_1.HeaderDescription, { className: "text-ellipsis" }, this.props.headingDescription))),
                React.createElement(Card_1.CardContent, { contentPadding: false }, this.props.items && this.props.items.length > 0 && this._getComponent())));
        };
        KubeCardWithTable.prototype._getComponent = function () {
            var tableProps = {
                className: "kube-list",
                showHeader: !this.props.hideHeaders,
                showLines: !this.props.hideLines,
                singleClickActivation: !!this.props.onItemActivated,
                itemProvider: new Provider_1.ArrayItemProvider(this.props.items),
                ariaLabel: this.props.headingText,
                columns: this.props.columns,
                onActivate: this._onItemActivated,
                onSelect: this._onItemSelected
            };
            return (React.createElement(Table_1.Table, __assign({}, tableProps)));
        };
        return KubeCardWithTable;
    }(React.Component));
    exports.KubeCardWithTable = KubeCardWithTable;
    function defaultColumnRenderer(text, contentClassName, tooltipText) {
        return (
        // show tooltip if specified, otherwise show only when element overflows
        React.createElement(TooltipEx_1.Tooltip, { text: tooltipText || text, overflowOnly: !tooltipText },
            React.createElement("span", { className: Util_1.css("text-ellipsis", contentClassName || "") }, text)));
    }
    exports.defaultColumnRenderer = defaultColumnRenderer;
    function renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender, statusProps, contentClassName) {
        var columnStyle = tableColumn.columnStyle;
        return (React.createElement(Table_1.SimpleTableCell, { className: Util_1.css(columnStyle === 2 /* Primary */ && "bolt-table-cell-primary", columnStyle === 1 /* Secondary */ && "bolt-table-cell-secondary", columnStyle === 3 /* Tertiary */ && "bolt-table-cell-tertiary"), contentClassName: contentClassName || "", columnIndex: columnIndex, tableColumn: tableColumn, key: columnIndex },
            statusProps && React.createElement(ResourceStatus_1.ResourceStatus, __assign({}, statusProps)),
            itemToRender));
    }
    exports.renderTableCell = renderTableCell;
    function renderTwoLineColumn(columnIndex, tableColumn, primaryText, subText, className, primaryTextClassName, secondaryTextClassName, statusProps) {
        return (React.createElement(Table_1.TwoLineTableCell, { className: className, columnIndex: columnIndex, tableColumn: tableColumn, line1: React.createElement("div", { className: Util_1.css("kube-list-col-data", primaryTextClassName), key: "col-primary-" + columnIndex },
                React.createElement(TooltipEx_1.Tooltip, { text: primaryText, overflowOnly: true },
                    React.createElement("span", { className: "text-ellipsis" }, primaryText))), line2: React.createElement("div", { className: Util_1.css("list-secondary-text", secondaryTextClassName), key: "col-secondary-" + columnIndex },
                React.createElement(TooltipEx_1.Tooltip, { text: subText, overflowOnly: true },
                    React.createElement("span", { className: "text-ellipsis" }, subText))), iconProps: statusProps ? { render: function (key) { return React.createElement(ResourceStatus_1.ResourceStatus, __assign({}, statusProps)); } } : {}, key: "col-" + columnIndex }));
    }
    exports.renderTwoLineColumn = renderTwoLineColumn;
    function renderPodNameWithStatusTableCell(rowIndex, columnIndex, tableColumn, podName, podStatusProps, statusTooltip, contentClassName) {
        return podName ? (React.createElement(Table_1.SimpleTableCell, { key: String_1.format("row-{0}-col-{1}", rowIndex, columnIndex), columnIndex: columnIndex, tableColumn: tableColumn },
            React.createElement(React.Fragment, null,
                podStatusProps &&
                    React.createElement(TooltipEx_1.Tooltip, { text: statusTooltip },
                        React.createElement("div", { className: "flex-row" },
                            React.createElement(Status_1.Status, __assign({}, podStatusProps, { ariaLabel: statusTooltip, className: "icon-large-margin", size: "16" /* m */ })))),
                React.createElement(TooltipEx_1.Tooltip, { overflowOnly: true, text: podName },
                    React.createElement("div", { className: Util_1.css("text-ellipsis", contentClassName) }, podName))))) : renderTableCell(rowIndex, columnIndex, tableColumn, null);
    }
    exports.renderPodNameWithStatusTableCell = renderPodNameWithStatusTableCell;
    function renderPodsStatusTableCell(rowIndex, columnIndex, tableColumn, podsCountString, podsStatusProps, tooltip, onClick, linkClassName) {
        var content = (React.createElement(React.Fragment, null,
            podsStatusProps && React.createElement(Status_1.Status, __assign({}, podsStatusProps, { size: "16" /* m */ })),
            React.createElement("div", { className: "k8s-pods-status-count body-m" }, podsCountString)));
        var classNames = "fontSizeM font-size-m flex-center flex-row text-ellipsis";
        var itemToRender = !podsCountString ? null :
            // show tooltip always if specified, otherwise show only when element overflows
            React.createElement(TooltipEx_1.Tooltip, { text: tooltip || podsCountString || "", overflowOnly: !tooltip }, onClick ? (React.createElement(Link_1.Link, { className: Util_1.css(classNames, "bolt-table-link", linkClassName || ""), ariaLabel: tooltip, rel: "noopener noreferrer", excludeTabStop: true, onClick: function (e) {
                    onClick();
                    e.preventDefault();
                } }, content))
                : (React.createElement("span", { className: classNames }, content)));
        return renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender, undefined, podsCountString ? "bolt-table-cell-content-with-link" : "");
    }
    exports.renderPodsStatusTableCell = renderPodsStatusTableCell;
    function onPodsColumnClicked(pods, item, itemKind, selectionActionCreator) {
        var selectedPod = pods.find(function (p) { return Utils_1.Utils.generatePodStatusProps(p.status).statusProps === Status_1.Statuses.Failed; }) || pods[0];
        // Item kind "Pod" implies that the type is an orphan pod
        var properties = itemKind === "Pod" ? undefined : {
            parentUid: item.metadata.uid
        };
        selectionActionCreator.selectItem({
            item: selectedPod,
            itemUID: (selectedPod && selectedPod.metadata.uid) || item.metadata.uid,
            selectedItemType: itemKind === "Pod" ? "orphan-pod" /* OrphanPodKey */ : "pod-details" /* PodDetailsKey */,
            showSelectedItem: true,
            properties: properties
        });
    }
    exports.onPodsColumnClicked = onPodsColumnClicked;
    function renderExternalIpWithCopy(textToDisplay, tooltipText, onCopyCompleted) {
        return (React.createElement("div", { className: "external-ip-cell flex-row flex-center" },
            React.createElement("div", { className: "external-ip-cell-text" }, textToDisplay || "-"),
            textToDisplay &&
                React.createElement(Button_1.Button, { onClick: function (e) {
                        e.preventDefault();
                        Utils_1.Utils.copyToClipboard(textToDisplay);
                        onCopyCompleted && onCopyCompleted(0);
                    }, onMouseLeave: function () { return onCopyCompleted && onCopyCompleted(-1); }, onBlur: function () { return onCopyCompleted && onCopyCompleted(-1); }, tooltipProps: { text: tooltipText || Resources.CopyExternalIp }, ariaLabel: tooltipText || Resources.CopyExternalIp, iconProps: { iconName: "Copy" }, className: "external-ip-copy-icon kube-text-copy", subtle: true })));
    }
    exports.renderExternalIpWithCopy = renderExternalIpWithCopy;
    function renderExternalIpCell(rowIndex, columnIndex, tableColumn, item, onCopyCompleted) {
        var textToRender = item.externalIP;
        var itemToRender = (React.createElement("div", { className: "external-ip-cell flex-row flex-center" },
            React.createElement("div", { className: "external-ip-cell-text" }, textToRender || "-"),
            textToRender &&
                React.createElement(Button_1.Button, { onClick: function (e) {
                        e.preventDefault();
                        Utils_1.Utils.copyToClipboard(textToRender);
                        onCopyCompleted && onCopyCompleted(rowIndex);
                    }, onMouseLeave: function () { return onCopyCompleted && onCopyCompleted(-1); }, onBlur: function () { return onCopyCompleted && onCopyCompleted(-1); }, tooltipProps: { text: item.externalIPTooltip || Resources.CopyExternalIp }, ariaLabel: item.externalIPTooltip || Resources.CopyExternalIp, excludeTabStop: true, iconProps: { iconName: "Copy" }, className: "external-ip-copy-icon kube-text-copy bolt-table-cell-content-reveal", subtle: true })));
        return renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender);
    }
    exports.renderExternalIpCell = renderExternalIpCell;
});
